import { css, Notes, Paragraph, Pill, styled } from 'canoe';

export const ContentCard = styled.a<{ showCheckbox?: boolean }>`
  ${({ theme, showCheckbox }) => css`
    width: 245px;
    max-width: 282px;
    height: 210px;
    margin: 1px;
    padding: ${theme.spaces.s};
    position: relative;
    background-color: ${theme.colors.White};
    border: 1px solid ${theme.colors.GlitterGrayL10};
    border-radius: ${theme.borderRadius.small};
    cursor: pointer;
    flex-grow: 1;
    flex-shrink: 0;

    &:hover,
    &.selected {
      border-color: ${theme.colors.AquaTeal};
      box-shadow: ${theme.boxShadow.outline(theme.colors.AquaTeal)};
    }

    :hover label {
      opacity: 1;
    }

    > label {
      opacity: ${showCheckbox ? '1' : '0'};
      position: absolute;
      left: ${theme.spaces.normal};
      top: ${theme.spaces.normal};
      z-index: 2;
    }
  `}
`;

export const CardThumbnailWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;
    cursor: pointer;
    position: relative;
    border-radius: ${theme.borderRadius.small};
    border: 1px solid ${theme.colors.GlitterGrayL10};
    margin-bottom: ${theme.spaces.s};

    // overlay on top of preview thumbnails to prevent interaction
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  `}
`;

export const CardThumbnail = styled.div<{ index?: number; thumbCount?: number }>`
  ${({ theme, index, thumbCount }) => css`
    flex-shrink: 0;
    position: relative;

    // thumbnail sizes
    ${(typeof index === 'undefined' && typeof thumbCount === 'undefined') ||
    (index === 0 && thumbCount === 1) ||
    (index === 2 && thumbCount === 3)
      ? css`
          height: 100%;
        `
      : css`
          height: 50%;
        `};

    // variants thumbnails layout borders
    ${thumbCount &&
    thumbCount > 1 &&
    index === 0 &&
    css`
      border-bottom: 1px solid ${theme.colors.GlitterGrayL10};
    `};

    ${thumbCount &&
    thumbCount > 2 &&
    css`
      ${(index === 0 || index === 1) &&
      css`
        border-right: 1px solid ${theme.colors.GlitterGrayL10};
      `}
    `};

    ${thumbCount &&
    thumbCount > 3 &&
    css`
      ${index === 2 &&
      css`
        border-bottom: 1px solid ${theme.colors.GlitterGrayL10};
      `}
    `};
  `}
`;

export const ContentStatusIndicator = styled(Pill)`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spaces.xs};
    right: ${theme.spaces.xs};
  `}
`;

export const VariantCountIndicator = styled(Notes)`
  ${({ theme }) => css`
    position: absolute;
    bottom: ${theme.spaces.xxs};
    right: ${theme.spaces.xxs};
    background-color: ${theme.colors.OnyxGray};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spaces.xxs};
    color: ${theme.colors.White};
    font-weight: ${theme.fontWeights.normal};
    font-size: 9px;
    margin: 0;
  `}
`;

export const CardTitle = styled(Paragraph)`
  font-size: 14px;
`;

export const CardTitleWithIcon = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: ${theme.spaces.xxs};
  `}
`;
